import { t } from 'i18next';

import { buildColumnsObject } from '@shape/lighthouse-components';
import { createListItemColumns } from './columnsConfig';
import { CaseListItem } from 'queries/cases/types';

export const getColumns = () => {
  return buildColumnsObject<CaseListItem>({
    columns: {
      ...createListItemColumns(),
    },
    getLabel: (key) => t(`case:tableColumns.${key}`),
  });
};
